import 'bootstrap/dist/css/bootstrap.min.css';
import React from "react";
import { Accordion } from 'react-bootstrap';
import Strings from "../globalization/pt-br/faq.json";

export const FAQPage: React.FC = () => {
    const FaqContent = () => {
        return (
            <>
                {Object.keys(Strings.content).map((key, index) => (
                    <Accordion.Item eventKey={index.toString()} key={key}>
                        <Accordion.Header>{Strings.content[key].title}</Accordion.Header>
                        <Accordion.Body>
                            <p dangerouslySetInnerHTML={{ __html: Strings.content[key].description }} />
                        </Accordion.Body>
                    </Accordion.Item>
                ))}
            </>
        );
    };

    return (
        <>
            <h1>{Strings.title}</h1>
            <Accordion className='mt-5'>
                {FaqContent()}
            </Accordion>
        </>
    );
}